export const ArrowRight = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" fill="none">
          <path fill="#546EDB" d="M20.707 8.707a1 1 0 0 0 0-1.414L14.343.929a1 1 0 1 0-1.414 1.414L18.586 8l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM0 9h20V7H0v2Z"/>
      </svg>
  )
}